import styled from "styled-components";
import * as Variable from "../../CSSVariables";

export const CartMessaging = styled.section`
  max-width: 1100px;
  margin: 0 auto;
  background-color: #fff7e9;
  color: #a55900;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #a55900;
  margin: 20px auto 0;
  width: 95%;

  @media only screen and (min-width: ${Variable.mobile}) {
    margin: 20px auto 60px;
    width: 100%;
  }

  input {
    position: absolute;
    opacity: 0;
    z-index: -1;
  }
  .tabs {
    .tab {
      width: 100%;
      overflow: hidden;

      &-label {
        display: flex;
        align-items: flex-start;
        width: 100%;
        padding: 1.2rem 1rem;
        font-weight: 700;
        text-align: left;
        cursor: pointer;
        position: relative;

        > img {
          width: 22px;
          margin-right: 1rem;
        }
        .tab-title {
          max-width: 80%;

          @media only screen and (min-width: ${Variable.tablet}) {
            max-width: unset;
          }
        }
        .tab-toggle {
          position: absolute;
          right: 12px;
          top: 47%;
          -webkit-transform: translateY(-47%);
          -ms-transform: translateY(-47%);
          transform: translateY(-47%);

          img {
            transform: rotate(180deg);
            transition: all 0.2s ease-in-out;
          }
        }
        &:hover {
          &::after {
            text-decoration: underline;
          }
        }
        &::after {
          color: #0251c6;
          position: absolute;
          right: 32px;
          font-weight: normal;
          top: 50%;
          -webkit-transform: translateY(-50%);
          -ms-transform: translateY(-50%);
          transform: translateY(-50%);
        }
      }
      &-content {
        max-height: 0;
        padding: 0 2rem;
        transition: all 0.35s ease;

        @media only screen and (min-width: ${Variable.tablet}) {
          padding: 0 4.4rem;
        }

        .msg-item {
          display: flex;
          flex-direction: column;

          &:not(:last-child) {
            margin-bottom: 2rem;
          }
          &:not(:first-child) {
            border-top: 1px solid rgb(165 89 0 / 20%);
            padding-top: 2rem;
          }
          .msg-title {
            font-weight: 500;
          }
          ul {
            margin: 0;
            padding-left: 3rem;

            li {
              margin-bottom: 0.6rem;
            }
          }

          .see-details {
            order: 1;
            margin: 0 0 0.5rem;

            &-toggle {
              text-decoration: underline;

              @media only screen and (min-width: ${Variable.mobile}) {
                br {
                  display: none;
                }
              }

              &:hover {
                cursor: pointer;
              }
              img {
                margin-left: 0.4rem;
                margin-top: -0.3rem;
              }
            }
            &-divider {
              border-left: 1px solid #9e9e9e;
              margin: 0 1.2rem;
            }
          }
          .list-see-more-check {
            ~ .more-list {
              display: none;
            }
            ~ .list-see-more-toggle {
              position: relative;

              img {
                transition: all 0.2s ease-in-out;
                transform: rotate(180deg);
              }
            }
          }
          .list-see-more-check:checked {
            ~ .more-list {
              display: block;
            }
            ~ .list-see-more-toggle {
              .showmore-label {
                display: none;
              }
              .list-see-more-label::after {
                content: "Show less";
              }
              img {
                transform: rotate(0deg);
              }
            }
          }
          .list-see-more-toggle {
            align-self: flex-start;
            list-style: none;
            text-decoration: underline;
            margin: 1rem 0 1rem 1rem;
            display: inline-block;
            order: 1;

            &:hover {
              text-decoration: underline;
            }
            img {
              margin-right: 1rem;
            }
            .list-see-more-label {
              cursor: pointer;
              font-weight: 500;
            }
          }
          &#secondhand-isbn {
            .msg-subtitle {
              margin-bottom: 0;
            }
            .secondhand-isbn-item {
              display: flex;
              flex-direction: column;
              margin-top: 12px;
            }
          }
        }
      }
    }
  }
  input:checked {
    + .tab-label {
      .tab-toggle {
        img {
          transform: rotate(0deg);
        }
      }
    }
    ~ .tab-content {
      max-height: 200vh;
      padding: 2rem;
      overflow: auto;

      @media only screen and (min-width: ${Variable.tablet}) {
        padding: 1rem 4.4rem;
      }
    }
  }
  .custom-messaging-modal {
    left: 0;
    color: ${Variable.black};

    .modal-bg {
      background-color: #fff;

      @media only screen and (min-width: ${Variable.tablet}) {
        background-color: #0000007a;
      }
    }
    .modal-content {
      border-radius: 4px;
      top: 0;
      transform: none;
      padding: 0;

      @media only screen and (min-width: ${Variable.tablet}) {
        top: 20px;
        max-height: calc(100vh - 40px);
        max-width: 400px;
      }

      .modal-header {
        text-align: right;

        button {
          display: inline-block;
          float: none;
          z-index: 1;
          position: relative;
          margin: 20px;

          @media only screen and (min-width: ${Variable.tablet}) {
            float: right;
          }
        }
      }
      .modal-body {
        border-radius: 4px;
        top: 0;
        transform: none;
        background-color: #fff;
        position: unset;
        padding: 0;

        .title {
          top: 0;
          width: 100%;
          position: absolute;
          margin: 0;
          font-size: 2rem;
          padding: 20px;
          border-bottom: 1px solid #dde2e2;

          @media only screen and (min-width: ${Variable.mobile}) {
            position: relative;
          }

          .warning-icon {
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
          }
        }

        .custom-messaging-modal-content {
          overflow-x: auto;
          max-height: calc(100vh - 154px);
          padding: 0 20px 20px;
          width: 100%;

          @media only screen and (min-width: ${Variable.mobile}) {
            max-height: 75vh;
          }

          .warning-note {
            color: ${Variable.milanoRed};
            border: 1px solid ${Variable.errorRed};
            border-radius: 6px;
            padding: 0.8rem 1.2rem;
            background-color: #fff4f5;
            display: flex;
          }
          .warning-icon-wrapper {
            padding-right: 12px;

            .warning-icon {
              width: 20px;
              margin-right: 0.5rem;
            }
          }
          ul.prod-item-list {
            padding: 0;
            list-style-type: none;

            li.prod-item {
              margin-bottom: 3rem;

              .prod-item-title {
                margin-bottom: 3rem;
                display: block;
                display: flex;

                .bullet {
                  padding: 0.6rem 0;
                  margin-left: 1.2rem;
                  writing-mode: vertical-lr;
                }
              }
              .product-card-wrapper {
                text-align: center;

                .product-card {
                  border: 2px solid #e0e0e0;
                  border-radius: 4px;
                  width: 200px;
                  margin: 0 auto;
                  display: inline-block;

                  .prod-card-isbn {
                    background-color: #f3f3f3;
                    padding: 1.2rem;
                    border-bottom: 2px solid #e0e0e0;
                  }
                  .prod-card-img {
                    padding: 2.5rem;

                    img {
                      width: 100%;
                    }
                  }
                }
              }
            }
          }
        }
        .custom-messaging-modal-footer {
          padding: 20px;
          border-top: 1px solid #dde2e2;
          text-align: right;
          bottom: 0;
          position: absolute;
          width: 100%;
          background-color: #fff;
          border-radius: 4px;

          @media only screen and (min-width: ${Variable.mobile}) {
            position: relative;
          }

          button {
            width: fit-content;
            margin: 0;
            display: inline-block;
          }
        }
      }
    }
  }
`;
